import { render, staticRenderFns } from "./LPLayout.vue?vue&type=template&id=62705f61&scoped=true"
import script from "./LPLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./LPLayout.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62705f61",
  null
  
)

export default component.exports